import { useState, useEffect, useRef, React } from 'react';
// material-ui
import { Box, Button, Grid, Typography, TextField } from '@mui/material';
import { useDispatch } from 'store';
import { IconUsers } from '@tabler/icons';
import { useFormik } from 'formik';
import { gridSpacing } from 'store/constant';
import BrandTitle from './BrandTitle';
import MainCard from 'ui-component/cards/MainCard';
import AnimateButton from 'ui-component/extended/AnimateButton';
import Slides from 'slides/AddCustomerLandscapeSlides';
import * as yup from 'yup';
import ConfirmationSlides from 'slides/ConfirmationSlides';
import LoadingButton from 'helpers/loadingButton'

const validationSchema = yup.object({
  customers: yup.number().required('Key account is required'),
});

const AddCustomerLandscape = () => {
  const [success, setSuccess] = useState(false);

  const dispatch = useDispatch();
  const colors = ['#f7c437', '#f9d057', '#fadc86', '#fceab5']

  const formik = useFormik({
    initialValues: {
      customers: '',
    },
    validationSchema,
    onSubmit: (data) => {
      console.log(data)
      dispatch(
        openSnackbar({
          open: true,
          message: 'Submit Success',
          variant: 'alert',
          alert: {
            color: 'success'
          },
          close: false
        }),
        postData(data),
        console.log(data)
      );
    }
  });

  return (
    <Grid container spacing={2}>

      <Grid item xs={12}>
        <BrandTitle title="Add" menuTitle="Customers" colors={colors} Icon={IconUsers} />
      </Grid>
      <Slides />
      <Grid item xs={12}>
        <MainCard title="Invite your existing customer base" sx={{ textAlign: 'center' }}>
          {!success &&
            <form onSubmit={formik.handleSubmit}>
              <Typography variant="h4" style={{ textAlign: 'center' }}>Invite your customers from social media, in store or mailing list to your Lolly brand profiles for free</Typography>
              <Grid container spacing={gridSpacing} mt={3}>
                <Grid item xs={12} sm={3}>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    id="customers"
                    name="customers"
                    label="How many customers do you want to invite for no cost?"
                    value={formik.values.customers}
                    onChange={formik.handleChange}
                    error={formik.touched.customers && Boolean(formik.errors.customers)}
                    helperText={formik.touched.customers && formik.errors.customers}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                </Grid>
                <Grid item xs={12} sm={3}>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <LoadingButton text="Add to my key accounts" setSuccess={setSuccess} />
                </Grid>
              </Grid>
            </form>
          }
          {success && <ConfirmationSlides />}
        </MainCard>
      </Grid>
    </Grid>
  );
}

export default AddCustomerLandscape;
